import { render, staticRenderFns } from "./CurrentApplication.vue?vue&type=template&id=6f42dbb6&scoped=true"
import script from "./CurrentApplication.vue?vue&type=script&lang=js"
export * from "./CurrentApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f42dbb6",
  null
  
)

export default component.exports